/*
 * Developed by quentinmalguy on 7/23/19 1:16 AM from Malguy Technology.
 * Last modified 7/23/19 1:12 AM.
 */

export const selectSubMenuIsOpen = (store) => store.navigation.submenu;
export const selectAudiencesMenuState = (store) => store.navigation.audiencesMenuState;
export const selectAudienceMenuState = (store) => store.navigation.audienceMenuState;
